import { apiRequest } from "../../services/apiService";
import { ADD_REPORT_PAGE_FAIL, ADD_REPORT_PAGE_REQUEST, ADD_REPORT_PAGE_SUCCESS, CHANGE_DEFAULT_REPORT_FAIL, CHANGE_DEFAULT_REPORT_REQUEST, CHANGE_DEFAULT_REPORT_SUCCESS, CREATE_REPORT_FAIL, CREATE_REPORT_REQUEST, CREATE_REPORT_SUCCESS, DELETE_REPORT_FAIL, DELETE_REPORT_PAGE_FAIL, DELETE_REPORT_PAGE_REQUEST, DELETE_REPORT_PAGE_SUCCESS, DELETE_REPORT_REQUEST, DELETE_REPORT_SUCCESS, DUPLICATE_PAGE_FAIL, DUPLICATE_PAGE_REQUEST, DUPLICATE_PAGE_SUCCESS, DUPLICATE_REPORT_FAIL, DUPLICATE_REPORT_REQUEST, DUPLICATE_REPORT_SUCCESS, GET_DEFAULT_REPORT_FAIL, GET_DEFAULT_REPORT_REQUEST, GET_DEFAULT_REPORT_SUCCESS, GET_REPORT_DETAILS_FAIL, GET_REPORT_DETAILS_REQUEST, GET_REPORT_DETAILS_SUCCESS, GET_REPORT_LIST_FAIL, GET_REPORT_LIST_REQUEST, GET_REPORT_LIST_SUCCESS, REORDER_PAGE_FAIL, REORDER_PAGE_REQUEST, REORDER_PAGE_SUCCESS, SET_CURRENT_REPORT, START_EDIT_MODE, STOP_EDIT_MODE, TOGGLE_REPORT_PAGE6_FAIL, TOGGLE_REPORT_PAGE6_REQUEST, TOGGLE_REPORT_PAGE6_SUCCESS, UPDATE_PAGE_FAIL, UPDATE_PAGE_REQUEST, UPDATE_PAGE_SUCCESS, UPDATE_REPORT_NAME_FAIL, UPDATE_REPORT_NAME_REQUEST, UPDATE_REPORT_NAME_SUCCESS } from "../constant";

export const startEditMode = () => {
    return { type: START_EDIT_MODE }
}

export const stopEditMode = () => {
    return { type: STOP_EDIT_MODE }
}

export const createReport = (data, successCallback = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: CREATE_REPORT_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/crtReport`,
            data: data
        })
        if (response) {
            const report_id = response.data?.data?.insertId
            const { response: pageResponse, error: pageError } = await apiRequest({
                method: 'POST',
                url: `/survey/addPage`,
                data: {
                    report_id,
                    survey_id: data.survey_id,
                    pageNo: 1,
                    content: '',
                    css: ''
                }
            })

            if (pageResponse) {
                dispatch({ type: CREATE_REPORT_SUCCESS })
                dispatch({ type: SET_CURRENT_REPORT, payload: report_id })
                successCallback()
            }
            else if (pageError) {
                dispatch({ type: CREATE_REPORT_FAIL })
            }
        }
        else if (error) {
            dispatch({ type: CREATE_REPORT_FAIL })
        }
    }
}

export const getReportDetails = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_REPORT_DETAILS_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/getReportDetails`,
            data: data
        })
        if (response) {
            dispatch({ type: GET_REPORT_DETAILS_SUCCESS, payload: response.data?.data })
        }
        else if (error) {
            dispatch({ type: GET_REPORT_DETAILS_FAIL })
        }
    }
}

export const getReportList = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_REPORT_LIST_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/getReportList`,
            data: data
        })
        if (response) {
            dispatch({ type: GET_REPORT_LIST_SUCCESS, payload: response.data?.data })
        }
        else if (error) {
            dispatch({ type: GET_REPORT_LIST_FAIL })
        }
    }
}


export const getDefaultReport = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_DEFAULT_REPORT_REQUEST });
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getDefaultReport?survey_id=${data}`,
        })
        if (response) {
            dispatch({ type: GET_DEFAULT_REPORT_SUCCESS, payload: response.data?.data })
        }
        else if (error) {
            dispatch({ type: GET_DEFAULT_REPORT_FAIL })
        }
    }
}

export const changeDefaultReport = (data, supplymentryData) => {
    return async (dispatch) => {
        dispatch({ type: CHANGE_DEFAULT_REPORT_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/chnageDefaultReport`,
            data: data
        })
        if (response) {
            dispatch({ type: CHANGE_DEFAULT_REPORT_SUCCESS, payload: supplymentryData })
        }
        else if (error) {
            dispatch({ type: CHANGE_DEFAULT_REPORT_FAIL })
        }
    }
}



export const addPage = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: ADD_REPORT_PAGE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/addPage`,
            data: data
        })

        if (response) {
            dispatch({ type: ADD_REPORT_PAGE_SUCCESS, payload: { page_no: data.pageNo, content: '', css: '', id: response.data?.data?.insertId } })
            successCallback({ page_no: data.pageNo, content: '', css: '', id: response.data?.data?.insertId })
        }
        else if (error) {
            dispatch({ type: ADD_REPORT_PAGE_FAIL })
        }
    }
}

export const changeReportName = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_REPORT_NAME_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updReportName`,
            data: data
        })

        if (response) {
            dispatch({ type: UPDATE_REPORT_NAME_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: UPDATE_REPORT_NAME_FAIL })
        }
    }
}

export const deletePage = (data) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_REPORT_PAGE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/delPage`,
            data: data
        })

        if (response) {
            dispatch({ type: DELETE_REPORT_PAGE_SUCCESS, payload: data.page_id })
        }
        else if (error) {
            dispatch({ type: DELETE_REPORT_PAGE_FAIL })
        }
    }
}


export const updatePage = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_PAGE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updPage`,
            data: data
        })

        if (response) {
            dispatch({ type: UPDATE_PAGE_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: UPDATE_PAGE_FAIL })
        }
    }
}

export const deleteReport = (data) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_REPORT_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/delReport`,
            data: data
        })

        if (response) {
            dispatch({ type: DELETE_REPORT_SUCCESS, payload: data.report_id })
        }
        else if (error) {
            dispatch({ type: DELETE_REPORT_FAIL })
        }
    }
}

export const duplicateReport = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: DUPLICATE_REPORT_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/duplicateReport`,
            data: data
        })

        if (response) {
            dispatch({ type: DUPLICATE_REPORT_SUCCESS, payload: { id: response?.data?.data?.insertId, ...data } })
            successCallback()
        }
        else if (error) {
            dispatch({ type: DUPLICATE_REPORT_FAIL })
        }
    }
}

export const duplicatePage = (data, supplymentryData, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: DUPLICATE_PAGE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/dupPage`,
            data: data
        })

        if (response) {
            const page = { ...supplymentryData, id: response?.data?.data?.insertId, page_no: data.page_order }
            dispatch({ type: DUPLICATE_PAGE_SUCCESS, payload: page })
            successCallback(page)
        }
        else if (error) {
            dispatch({ type: DUPLICATE_PAGE_FAIL })
        }
    }
}

export const reOrderPages = (data) => {
    return async (dispatch) => {
        dispatch({ type: REORDER_PAGE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/reOrderPages`,
            data: data
        })

        if (response) {
            dispatch({ type: REORDER_PAGE_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: REORDER_PAGE_FAIL })
        }
    }
}

export const toggleReportPage6 = (data) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_REPORT_PAGE6_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/toggleReportPage6`,
            data: data
        })

        if (response) {
            dispatch({ type: TOGGLE_REPORT_PAGE6_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: TOGGLE_REPORT_PAGE6_FAIL })
        }
    }
}







